import { FC, useContext, useEffect, useState } from "react";
import { Button, CustomLink, Input, Keyboard, Layout } from "../components";
import logo from "../assets/logo.svg";
import { Context } from "..";
import { useNavigate } from "react-router-dom";
import $api from "../http";
import config from "../config";
import { observer } from "mobx-react";

const RegisterClient: FC<{ title: string }> = observer(({ title }) => {
  const { store } = useContext(Context);
  const navigate = useNavigate();

  useEffect(() => {
    if (!store.isAuth) return navigate("/");
  }, [store, navigate]);

  const [name, setName] = useState<string>("");
  const [isShift, setShift] = useState<boolean>(false);

  const sendData = () => {
    if (!name) setName("Безымянный");
    $api.post(`${config.API}/client/register`, { phone: store.order.phone, name }).then(({ data }) => {
      if (data.status === "error") return alert(data.message);
      store.setClientName(name);
      store.setJoins(0);
      navigate("/default/order");
    });
  };

  return (
    <Layout title={title}>
      <img src={logo} alt="Chiorio logotype" width={128} height={128} />
      <CustomLink to={"/default/phone"}>{"<-"} Ввод номера</CustomLink>
      <Input placeholder="Имя клиента" value={name} onChange={({ target }) => setName(target.value)} />
      <Keyboard
        isUpperCase={isShift}
        onClick={(e: string) => {
          if (e === "<-") return setName((prev) => prev.substring(0, prev.length - 1));
          if (e === "SH") return setShift((prev) => !prev);
          setName((prev) => {
            if (prev.length < 1) return (prev += e.toUpperCase());
            return (prev += e);
          });
        }}
      />
      <Button onClick={sendData}>Продолжить</Button>
    </Layout>
  );
});

export default RegisterClient;
